<template>
    <span class="typo-number" @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
        <span class="product-ean">
            {{ean}}
            <div v-if="showTooltip" class="product-ean__tooltip">
                <h6>{{title}}</h6>
            </div>
        </span>
    </span>
</template>

<script>
export default {
    data() {
        return {
            showTooltip: false
        }
    },
    props: {
        ean: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.product-ean {
    position: relative;
    &__tooltip {
        font-weight: 400;
        min-width: 200px;
        background-color: #fff;
        color: #041e42;
        text-align: left;
        border-radius: 6px;
        padding: 10px 10px;
        position: absolute;
        z-index: 1;
        bottom: 150%;
        left: 50%;
        transform: translateX(-50%);
        transition: opacity 0.3s;
        box-shadow: 0px 0px 1px #999;
        font-size: 12px;
        color: #999;
        &:after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #fff transparent transparent transparent;
        }
    }
}
</style>